import { translationChunksConfig } from '@spartacus/assets';
import { Config } from '@spartacus/core';
import { layoutConfig } from '@spartacus/storefront';
import { environment } from '../../environments/environment';

export const knBrStorefrontConfig: Config = {
  backend: {
    occ: {
      baseUrl: environment.BASEURL,
      prefix: environment.PREFIX,
    },
  },
  context: {
    currency: ['USD', 'CAD'],
    language: ['en', 'fr_CA'],
    baseSite: environment.BASE_SITE,
  },
  features: {
    level: '*',
  },
  i18n: {
    chunks: translationChunksConfig,
  },
  routing: {
    protected: true,
  },
  layoutSlots: layoutConfig.layoutSlots,
};
